{
	if (
		!document.documentElement
		|| document.documentElement.getAttribute('data-browser') !== 'Edge'
	) {
		// Luister naar het 'beforeinstallprompt' event
		window.addEventListener('beforeinstallprompt', (event) => {
			event.preventDefault();
			window._StoredPWAPrompt = event; // Sla het event op
		});
	}
}

onInteractive(() => {
	if (
		!document.documentElement
		|| document.documentElement.getAttribute('data-browser') !== 'Edge'
	) {
		document.body.querySelectorAll('[data-purpose="install-pwa"]')
			.forEach(element => {
				element.addEventListener('click', () => {
					if (window._StoredPWAPrompt) {
						window._StoredPWAPrompt.prompt()
					} else if (window._PWA_Alternative_URL) {
						document.location.href = window._PWA_Alternative_URL
					} else {
						alert('Geen installatie url gevonden. Probeer het nogmaals.');
					}
				})
			})
	}

	//Fix formbuilder labels with dot
	document.body.querySelectorAll('.form-mailto p.font-weight-bold')
		.forEach((element) => {
			if (element.innerHTML == '.')
				element.setAttribute('style', 'opacity:0')
		})

	//Shortcut
	document.body.querySelectorAll('#adminbar .dropdown-toggle')
		.forEach((element) => {
			if (element.parentNode.querySelectorAll('.dropdown-menu a').length == 1) {
				element.parentNode.querySelector('.dropdown-menu').classList.add('d-none')
				element.addEventListener('click', (event) => {
					event.preventDefault()
					element.parentNode.querySelector('.dropdown-menu a').click()
				})
			}
		})

	//Update install buttons
	const pwaSelectors = '.d-none-pwa,.d-pwa,.d-sm-none-pwa,.d-sm-pwa,.d-md-none-pwa,.d-md-pwa';
	if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
		//Is PWA
		document.body.querySelectorAll(pwaSelectors)
			.forEach((element) => {
				element.classList.add('pwa');
			})
	} else {
		//Is not PWA
		document.body.querySelectorAll(pwaSelectors)
			.forEach((element) => {
				element.classList.add('non-pwa');
			})
	}
})

onComplete(() => {
	//Update links
	if (window.editor) {
		let mode = document.body.getAttribute('data-editor-mode')

		window.editor.addEventListener('changed-mode', (event) => {
			mode = event.mode
		})

		const links = Array.from(
			document.querySelectorAll('a.nav-link[href],a.dropdown-item[href]')
		)
		const setupLink = (element) => {
			element.addEventListener('click', (event) => {
				if (mode !== 'content') {
					return
				}
				if (event.target.closest('.gallery-image-editable')) {
					event.preventDefault()
					event.stopImmediatePropagation()
				}
			})
		}
		for (let i = 0; i < links.length; i++) {
			setupLink(links[i])
		}
	}

	//Disable Right Click
	function disableRightClick() {
		document.addEventListener("contextmenu", function (event) {
			event.preventDefault();
		});
	}
	disableRightClick();

	// //Right mousebutton disable:
	document.addEventListener('contextmenu', event => {
		event.preventDefault();
	});
});